import { Checkbox, Col, Form, Input, InputNumber, Row, Select, Typography } from "antd";
import { useIntl } from "react-intl";
import { createMaxPlayersValidator } from "~Features/MatchProfiles/shared/maxPlayersValidator";
import {MatchProfileNumberFormInput} from "~Features/MatchProfiles/shared/MatchProfileNumberFormInput";

const checkboxOptions = [
  { value: 1, label: "P1" },
  { value: 2, label: "P2" },
  { value: 3, label: "P3" },
  { value: 4, label: "P4" },
  { value: 11, label: "OT1" },
  { value: 12, label: "OT2" },
  { value: 13, label: "OT3" },
  { value: 14, label: "OT4" },
  { value: 15, label: "OT5" },
  { value: 16, label: "OT6" },
];

const Ice3Form = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 16 }}
            required={true}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Please input name",
              },
            ]}
            label={formatMessage({
              id: "name",
              defaulMessage: "Name",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"defaultProfile"}
            label={formatMessage({
              id: "defaultProfile",
              defaulMessage: "Default Profile",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Typography.Title level={4}>Profile</Typography.Title>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"numberOfPeriods"}
            label={formatMessage({
              id: "number.of.periods",
              defaultMessage: "numberOfPeriods",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"periodLength"}
            label={formatMessage({
              id: "period.length",
              defaultMessage: "periodLength",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"halfTimeDuration"}
            label={formatMessage({
              id: "half.time.duration",
              defaultMessage: "halfTimeDuration",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"periodBreakDuration"}
            label={formatMessage({
              id: "period.break.duration",
              defaultMessage: "periodBreakDuration",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maximumRosterSize"}
            label={formatMessage({
              id: "maximum.roster.size",
              defaultMessage: "maximumRosterSize",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"overtimeAllowed"}
            label={formatMessage({
              id: "overtime.allowed",
              defaultMessage: "overtimeAllowed",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"overtimeLength"}
            label={formatMessage({
              id: "overtime.length",
              defaultMessage: "overtimeLength",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <Form.Item
            name={"shootoutSeconds"}
            label={formatMessage({
              id: "shoot.out.if.tie",
              defaultMessage: "Shootout If Tie?",
            })}
          >
            <Select>
              <Select.Option value={false}>No</Select.Option>
              <Select.Option value={true}>Yes</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"timeoutsPerMatch"}
            label={formatMessage({
              id: "number.of.match.timeouts",
              defaultMessage: "Number of Match Timeouts",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"maximumPlayersOnField"}
            label={formatMessage({
              id: "maximum.players.on.ice",
              defaultMessage: "Maximum players on ice",
            })}
            rules={[
              ({ getFieldValue }) =>
                createMaxPlayersValidator(getFieldValue, formatMessage, "form.matchProfile.error.maximumPlayersOnField"),
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={6}>
          <MatchProfileNumberFormInput
            name={"shotsUntilSuddenDeath"}
            label={formatMessage({
              id: "shots.until.sudden.death",
              defaultMessage: "Shots until sudden death",
            })}
          >
            <InputNumber style={{ width: "100%" }} />
          </MatchProfileNumberFormInput>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"switchPlayingDirection"}
            label={formatMessage({
              id: "switch.play.direction",
              defaultMessage: "switchPlayingDirection",
            })}
          >
            <Checkbox.Group options={checkboxOptions}></Checkbox.Group>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            name={"resetTimeoutsAfterPeriods"}
            label={formatMessage({
              id: "reset.timeouts.after.periods",
              defaultMessage: "resetTimeoutsAfterPeriods",
            })}
          >
            <Checkbox.Group options={checkboxOptions} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default Ice3Form;
